import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { Lightbox } from '../ui/Lightbox';
import { promos, type Promo } from '../../data/promos';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
export function PromoCarousel() {
  const [zoom, setZoom] = useState<Promo | null>(null);
  return <div data-id="element-300" data-mp="2tppz1iq65o73">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-301" data-mp="2tpzsxhec4fi2">
        <p className="text-[15px] font-semibold text-white md:text-base" data-id="element-302" data-mp="2tnnal34o034h">
          😎 ¿Querés que te mandemos más info?
        </p>
        <a href={whatsappLink(GENERAL_WA_MESSAGE)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[13.5px] font-semibold text-neon-soft transition-colors duration-150 ease-smooth hover:text-white" data-id="element-303" data-mp="33erhdfk6sho8">
          <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-304" data-mp="3heiz9rdtqi7i" />
          Pedila por WhatsApp
        </a>
      </div>

      <div className="vc-marquee-wrap relative mt-4 overflow-hidden" style={{
      maskImage: 'linear-gradient(to right, transparent, black 4%, black 96%, transparent)',
      WebkitMaskImage: 'linear-gradient(to right, transparent, black 4%, black 96%, transparent)'
    }} data-id="element-305" data-mp="2ssm5ehgxc69i">
        <div className={`vc-marquee vc-marquee-reverse flex w-max items-start gap-3 ${zoom ? 'vc-marquee-paused' : ''}`} data-id="element-306" data-mp="2etuxxdwkhiuc">
          {[...promos, ...promos].map((promo, i) => {
          const duplicated = i >= promos.length;
          return <button key={`${promo.id}-${i}`} type="button" onClick={() => setZoom(promo)} tabIndex={duplicated ? -1 : undefined} aria-label={`Ampliar la placa: ${promo.titulo}`} className="shrink-0 overflow-hidden rounded-xl border border-line/80 bg-surface2/40 transition-colors duration-150 ease-smooth hover:border-neon/60" data-id="element-307" data-mp="32nmi7ju3qain" data-mpi={i}>
                <img src={promo.imagen} alt={duplicated ? '' : promo.titulo} loading="lazy" className="h-[170px] w-auto object-contain md:h-[200px]" data-id="element-308" data-mp="i5sdtdqy4spe" />
              </button>;
        })}
        </div>
      </div>

      <AnimatePresence data-id="element-309" data-mp="3qksulbkqkext">
        {zoom ? <Lightbox src={zoom.imagen} alt={zoom.titulo} onClose={() => setZoom(null)} data-id="element-310" data-mp="3qn5bdlercj9a" /> : null}
      </AnimatePresence>
    </div>;
}